import OneMonthFreeCard from 'app/components/one-month-free-card';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { theme } from './shared';

export const ReferralProgram = ({ available }: { available: boolean }) => {
  const { t } = useScopedTranslation();
  if (!available) return null;

  return (
    <Column
      alignItems="center"
      gap="spacing.general.x4"
      style={{
        borderColor: theme.colors['surface.tertiary'],
        borderRadius: theme.borderRadii['radius.xl'],
        borderWidth: 1,
        padding: theme.spacing['spacing.general.x4'],
        marginHorizontal: theme.spacing['spacing.general.x5'],
      }}
    >
      <Text fontWeight="700" textAlign="center" variant="headerXSmall">
        {t(`referralProgram.title`)}
      </Text>
      <Text marginHorizontal="spacing.general.x4" textAlign="center" variant="bodyBase">
        {t(`referralProgram.subtitle`)}
      </Text>
      <OneMonthFreeCard />
    </Column>
  );
};
